import { useState, useEffect } from 'react';
import { OnBoardingRequirementsSelect } from '../../../../common/APICommon';
//icons
import ErrorIcon from '@mui/icons-material/Error';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

export const AddUpdateRequirementModal = ({ visible, onClose, onSave, modalName,
  data,
  onBoardingRequirements, setOnBoardingRequirements,
  file, setFile,
  hasCompleted, setHasCompleted,
  isActive, setIsActive,
}) => {
  //Request Messages -start
  const [showRequestMessage, setShowRequestMessage] = useState(false);
  const [requestMessage, setRequestMessage] = useState("");
  const [isSuccess, setIsSuccess] = useState("");
  useEffect(() => {
    if (showRequestMessage) {
      const timeoutId = setTimeout(() => {
        setShowRequestMessage(false);
      }, 5000);

      return () => clearTimeout(timeoutId);
    }

  }, [showRequestMessage]);
  function GenerateMessage({ form, message, isSuccess }) {
    return (
      <>
        <div className={`modal-overlay toggleMessage-overlay ${form ? 'open' : ''}`}>
          {form && (
            <div className="modal toggleMessage" style={{ backgroundColor: isSuccess ? "#E0FFDC" : "#ffd0c5" }}>
              <div className='column'>
                {isSuccess ?
                  <div className='request_title row' style={{ fontWeight: "bold", color: "green", alignItems: "center" }}>
                    <CheckCircleIcon />
                    <span >{"SUCCESS MESSAGE"}</span>
                  </div>
                  :
                  <div className='request_title row' style={{ fontWeight: "bold", color: "#DD5746", alignItems: "center" }}>
                    <ErrorIcon />
                    <span>{"ERROR MESSAGE"}</span>
                  </div>
                }
                <span style={{ textAlign: "center", padding: "10px 0", color: isSuccess ? "green" : "#DD5746" }}>{message}</span>
              </div>
            </div>
          )}
        </div>
      </>
    );
  }
  //Request Messages -end

  // for upload
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    setFile(file);
  };

  if (!visible) return null;

  const handleSubmit = async () => {
    if (!onBoardingRequirements) {
      setShowRequestMessage(true);
      setIsSuccess(false);
      setRequestMessage(`Please fill up required field/s.`);
      return;
    }

    await onSave();
    closeModal();
  };

  const resetLocalVariables = () => {
    setShowRequestMessage(false)
  }

  const closeModal = () => {
    onClose();
    resetLocalVariables();
  }

  return (
    <>
      <div className="fixed inset-0 z-[3001] flex items-center justify-center bg-black bg-opacity-50 text-gray-600">
        <div className="w-full max-w-md rounded-lg bg-white p-6 shadow-lg">
          <h2 className="mb-4 text-2xl font-semibold">{modalName}</h2>

          <div className="short:max-h-[300px] medium:h-[400px] mt-10 max-h-[500px] space-y-5 overflow-y-auto">
            <div>
              <label className="mb-1 block text-sm font-medium">
                Requirements <span className="text-red-500">*</span>
              </label>

              <div>
                <OnBoardingRequirementsSelect data={onBoardingRequirements} setData={setOnBoardingRequirements} isEditable={true} hasAll={false} />
              </div>
            </div>
            <div>
              <label className="mb-1 block text-sm font-medium">
                File
              </label>
              <div className="info-item-input">
                <label htmlFor="file-input" className='column' style={{
                  color: "#808080b5",
                  fontSize: "14px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer" // Add cursor pointer for better user interaction
                }}>
                  {!file && <img src={"images/upload-image.png"} alt="" style={{ width: "auto", height: "200px" }}></img>}
                  {file ? file.name : "Click the placeholder to upload a logo"}
                </label>
                <input
                  id="file-input"
                  type="file"
                  style={{ display: "none" }}
                  onChange={handleFileChange}
                />
              </div>
              <span style={{
                visibility: "hidden",
                color: "#ff6565",
                fontSize: "12px"
              }}>Please fill up this field
              </span>

              {file &&
                <>
                  <div className='w-full'>
                    <button
                      className={"bg-blue-500 hover:bg-blue-600 border-none cursor-pointer p-1 px-2 text-white my-1 rounded-sm"}
                      onClick={() => {
                        const url = URL.createObjectURL(file); // create a blob URL
                        const link = document.createElement("a");
                        link.href = url;
                        link.download = file.name || "download"; // use file name if available
                        link.click();
                        URL.revokeObjectURL(url); // cleanup
                      }}
                    >
                      View File
                    </button>
                  </div>
                </>}
            </div>
            <div>
              <label className="mb-1 inline-flex items-center text-sm font-medium">
                <input
                  type="checkbox"
                  checked={hasCompleted}
                  onChange={(e) => setHasCompleted(e.target.checked)}
                  className="mr-2"
                />
                Has Completed?
              </label>
            </div>
            <div>
              <label className="mb-1 inline-flex items-center text-sm font-medium">
                <input
                  type="checkbox"
                  checked={isActive}
                  onChange={(e) => setIsActive(e.target.checked)}
                  className="mr-2"
                />
                Is Active?
              </label>
            </div>
          </div>

          <div className="mt-6 flex justify-end space-x-2">
            <button
              className="cursor-pointer rounded-md border-none bg-blue-600 px-4 py-2 text-white transition hover:bg-blue-700"
              onClick={handleSubmit}
            >
              Save
            </button>
            <button
              className="cursor-pointer rounded-md border-none bg-red-600 px-4 py-2 text-white transition hover:bg-red-700"
              onClick={closeModal}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>

      <GenerateMessage form={showRequestMessage}
        message={requestMessage}
        isSuccess={isSuccess}
      >
      </GenerateMessage>
    </>
  );
};